<template>
  <div id="app">
    <BaseLayoutCustomComponent />
  </div>
</template>
<script>
import BaseLayoutCustomComponent from '@/components/BaseLayout-custom'
export default {
  components: {
    BaseLayoutCustomComponent
  }
}
</script>
